import { Switch, useRouteMatch } from 'react-router-dom';

import { DoctorRoute } from 'components/atoms/DoctorRoute';
import { PatientInfo } from 'components/pages/PatientInfo';

export default function PatientInfoScreen() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <DoctorRoute exact component={PatientInfo} path={path} />
    </Switch>
  );
}
